<template>
  <div class="blockGraph">
    <span>Last {{ numDays }} Days</span>
    <div class="flexRow graph">
      <static-block-row
        v-for="day in days"
        :quota="day.quota"
        :completed="day.completed"
        :color="color"
        :label="day.label"
        size="small"
        orientation="vertical"
        :maxNumBlocks="12"
      /><!-- FIXME - CALCULATE THIS BASED ON SPACE AVAILABLE PLEASE -->
    </div>
    <div class="stats">
      <span class="total">{{ total }} blocks total</span>
      <br />
      <span class="average">{{ average }} blocks/day</span>
    </div>
  </div>
</template>

<script>
import StaticBlockRow from "./StaticBlockRow.vue";

import util from "../util.js";
import categoryUtil from "../categoryUtil.js";

export default {
  name: "block-graph",
  components: {
    "static-block-row": StaticBlockRow,
  },
  props: {
    categoryId: String,
    numDays: {
      type: Number,
      default: 7,
    },
    // Max height in pixels - FIXME - IMPLEMENT THIS
    maxHeight: {
      type: Number,
      default: 400,
    },
  },
  data() {
    return {
      total: 0,
      average: 0,
    };
  },
  computed: {
    days() {
      let days = util.getLastXDays(this.numDays);
      const id = this.categoryId;
      this.total = 0;
      this.average = 0;

      for (let i = 0; i < days.length; i++) {
        const date = days[i];
        const includeChildren = !categoryUtil.getShowChildren(id);
        const quota = categoryUtil.getQuota(id, date, includeChildren);
        const completed = categoryUtil.getCompleted(id, date, includeChildren);
        const label = moment(date, util.dateString).format("dd");

        this.total += completed;

        days[i] = {
          quota: 0,
          completed,
          label,
        };
      }

      this.average = Math.round((this.total / this.numDays) * 10) / 10;

      return days;
    },
    color() {
      return categoryUtil.getColor(this.categoryId);
    },
  },
};
</script>

<style scoped>
.flexRow {
  align-items: flex-end;
  justify-content: center;
}

.blockGraph {
  margin: 2rem 1rem;
}

.graph {
  /*min-height: 6rem;*/
  margin-top: 2rem;
}

.flexRow.blockRow {
  padding: 0.25rem;
}

.stats {
  font-size: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// BlockGraph.vue?82524e94